import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import * as React from 'react';
import * as PropTypes from 'prop-types';
import RcRate from 'rc-rate';
import Icon from '../icon';

var Rate = function (_React$Component) {
    _inherits(Rate, _React$Component);

    function Rate() {
        _classCallCheck(this, Rate);

        var _this = _possibleConstructorReturn(this, (Rate.__proto__ || Object.getPrototypeOf(Rate)).apply(this, arguments));

        _this.saveRate = function (node) {
            _this.rcRate = node;
        };
        return _this;
    }

    _createClass(Rate, [{
        key: 'focus',
        value: function focus() {
            this.rcRate.focus();
        }
    }, {
        key: 'blur',
        value: function blur() {
            this.rcRate.blur();
        }
    }, {
        key: 'render',
        value: function render() {
            return React.createElement(RcRate, _extends({ ref: this.saveRate }, this.props));
        }
    }]);

    return Rate;
}(React.Component);

export default Rate;

Rate.propTypes = {
    prefixCls: PropTypes.string,
    character: PropTypes.node
};
Rate.defaultProps = {
    prefixCls: 'ant-rate',
    character: React.createElement(Icon, { type: 'star' })
};


//////////////////
// WEBPACK FOOTER
// ./~/antd/es/rate/index.js
// module id = 1384
// module chunks = 0